import { Principal } from '@state/reducers/auth/auth.models';

export class XlsFileUploadedMessage {
    public tenantId: string;
    public userId: string;
    public reportType: number;


    static fromJson(json: string): XlsFileUploadedMessage {
        const data = JSON.parse(json);
        const instance = new XlsFileUploadedMessage();
        Object.assign(instance, data);
        return instance;
    }

    public isForPrincipal(principal: Principal) {
        return this.tenantId === principal.tenantId && this.userId === principal.userId;
    }
}

export class InvitationBulkImportMessage {
    public tenantId: string;
    public eventId: string;
}
